import { render, staticRenderFns } from "./AreaLogadaLayout.vue?vue&type=template&id=6dd641e3&"
import script from "./AreaLogadaLayout.vue?vue&type=script&lang=js&"
export * from "./AreaLogadaLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports